
/*
    Persist values between pjax navigations
*/

function pjaxPersister() {

    let storage = {};

    let tryGetFn = function (key, out) {
        if (Object.prototype.toString.call(out) !== '[object Object]') {
            throw 'Out parameter must be an object';
        }

        if (typeof storage[key] === 'undefined') {
            out.value = null;
            return false;
        }

        out.value = storage[key];
        return true;
    };

    let isTrueFn = function (key) {
        let out = {};
        if (tryGetFn(key, out)) {
            return !!out.value;
        }
        return false;
    };

    return {
        tryGet: tryGetFn,

        isTrue: isTrueFn,

        isFalse: function (key) {
            return !isTrueFn(key);
        },

        set: function (key, value) {
            if (!key || typeof key !== 'string') {
                throw 'Missing key in call';
            }

            storage[key] = value;
        },

        _debug: function () {
            return storage;
        }
    };
}

module.exports = pjaxPersister();


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/pjax-persister.js